import React, {useEffect} from "react";
import VideoBanner from "../components/VideoBanner";
import LastPosts from "../components/LastPosts";
import LastNews from "../components/LastNews";
import Customers from "../components/Customers";
import Services from "../components/Services";
import ImageBanner from "../components/ImageBanner";
import Benefit from "../components/Benefit";
import ContactUs from "../components/ContactUs";
import {useSettingState} from "../context/SettingContext";
import configs from '../utils/config.json';
import {useDataState} from "../context/DataContext";


const Index = (props) => {
    const setting = useSettingState();
    const data=useDataState();
    useEffect(() => {
        window.scrollTo(0, 0);

    }, []);
    return <>
        <VideoBanner video={`${configs.server.Storage}/${setting.state.home.videoBanner.video}`}
                     showButton1={setting.state.home.videoBanner.hasButton1}
                     showButton2={setting.state.home.videoBanner.hasButton2}
                     title1={setting.state.home.videoBanner.title}
                     title2={setting.state.home.videoBanner.description}
                     Button1Text={setting.state.home.videoBanner.Button1Text}
                     Button1Link={setting.state.home.videoBanner.Button1Link}
                     Button2Text={setting.state.home.videoBanner.Button2Text}
                     Button2Link={setting.state.home.videoBanner.Button2Link}
        />
        <LastPosts title={setting.state.home.lastNewTitle} content={data.state.news.data.slice(0,3)}/>
        <Services content={data.state.service}/>
        <ImageBanner image={`${configs.server.Storage}/${setting.state.home.imageBanner.img}`} title={setting.state.home.imageBanner.title}/>
        <Benefit video={`${configs.server.Storage}/${setting.state.home.benefit.video}`} title={setting.state.home.benefit.title} content={data.state.benefit}/>
        <Customers title={setting.state.home.customersTitle} content={data.state.customer.slice(0,5)}/>
        <LastNews title={setting.state.home.newsTitle} content={data.state.news.data.slice(0,5)}/>
        <ContactUs/>
    </>;
}
export default Index;